<template>
    <div>
        <v-container fluid class="py-0 py-md-3">
            
            <v-row class="d-md-none" v-if="path != '/furniture'">
                <v-col>

                    <div class="position-relative">
                        <v-carousel height="auto" :hide-delimiters="true">
                            <v-carousel-item v-for="(favorite,fav_id) in favorites" :key="'fav-'+fav_id">
                                <template v-if="$route.name == 'Furniture' || ($route.name == 'FurnitureCategory' && $route.params.url == favorite.category.url) || ($route.params.url == 'new' && favorite.new)">
                                    <div>
                    
                                    <!-- <router-link :to="'/product/'+favorite.url"> -->
                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+favorite.cover.path" :contain="false" height="300"></v-img>
                                    <!-- </router-link> -->
                    
                                        <v-row class="d-md-none" justify="center">
                                            <v-col cols="11" class="py-0">
                    
                                                <div class="my-3">
                                                    <span class="bold product-title">{{favorite.productNameLabelBold}}</span> <span class="product-title">{{favorite.productNameLabel}}</span>
                                                </div>
                    
                                                <!-- <span class="bold d-block">DESCRIPTION</span> -->
                    
                                                <template v-for="(detail_item, di) in favorite.details">
                                                    <template v-if="detail_item.field.type == 'wysiwyg'">
                                                        <div :key="'detail-item-'+di" v-html="detail_item.value">
                    
                                                        </div>
                                                    </template>
                                                    <template v-if="detail_item.field.type == 'textarea'">
                                                        <p style="white-space: break-space;" :key="'detail-item-'+di">{{detail_item.value}}</p>
                                                    </template>
                                                </template>
                    
                    
                                                <span class="bold d-block">DIMENSIONS</span>
                                                <template v-for="(detail_item, di) in favorite.dimensions">
                                                    <template v-if="detail_item.field.type == 'text'">
                                                        <span
                                                        class="bold d-block product-subtitle"
                                                        :key="'dimension-item-'+di"
                                                        >{{detail_item.value}}</span>
                                                    </template>
                    
                                                    <template v-if="detail_item.field.type == 'textarea'">
                                                        <p style="white-space: break-space;" :key="'dimension-item-'+di">{{detail_item.value}}</p>
                                                    </template>
                    
                                                    <template v-if="detail_item.field.type == 'wysiwyg'">
                                                        <div :key="'dimension-item-'+di" v-html="detail_item.value"></div>
                                                    </template>
                    
                                                </template>
                    
                    
                                                <v-btn outlined color="black" tile :to="'/product/'+favorite.url" width="184" height="55" class="mt-6 btn-shop-now ">
                                                    <span>SHOP <span class="bold" :ripple="false" elevation="0">NOW</span></span>
                                                </v-btn>
                    
                                            </v-col>
                                        </v-row>
                                    </div>
                                </template>
                            </v-carousel-item>
                        </v-carousel>
                    </div>

                </v-col>
                
                <!-- <v-carousel 
                    v-model="carousel" 
                    height="300" 
                    :hide-delimiters="true"
                    :show-arrows="true"
                    next-icon="chevron-right"
                    prev-icon="chevron-left"
                    light
                >
                    <v-carousel-item v-for="(favorite,fav_id) in favorites" :key="'fav-'+fav_id">
                        <template v-if="$route.name == 'Furniture' || ($route.name == 'FurnitureCategory' && $route.params.url == favorite.category.url) || ($route.params.url == 'new' && favorite.new)">
                            <router-link :to="'/product/'+favorite.url">
                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+favorite.cover.path" :contain="false" height="300"></v-img>
                            </router-link>
                        </template>
                    </v-carousel-item>
                </v-carousel> -->
            </v-row>

            <!-- <template v-for="(favorite,fav_id) in favorites">
                <template v-if="$route.name == 'Furniture' || ($route.name == 'FurnitureCategory' && $route.params.url == favorite.category.url) || ($route.params.url == 'new' && favorite.new)">
                    <v-row :key="'fav-'+fav_id" v-if="fav_id == carousel" class="d-md-none" justify="center">
                        <v-col cols="11" class="py-0">

                            <div class="my-3">
                                <span class="bold product-title">{{favorite.productNameLabelBold}}</span> <span class="product-title">{{favorite.productNameLabel}}</span>
                            </div>

                            <template v-for="(detail_item, di) in favorite.details">
                                <template v-if="detail_item.field.type == 'wysiwyg'">
                                    <div :key="'detail-item-'+di" v-html="detail_item.value">

                                    </div>
                                </template>
                                <template v-if="detail_item.field.type == 'textarea'">
                                    <p style="white-space: break-space;" :key="'detail-item-'+di">{{detail_item.value}}</p>
                                </template>
                            </template>


                            <span class="bold d-block">DIMENSIONS</span>
                            <template v-for="(detail_item, di) in favorite.dimensions">
                                <template v-if="detail_item.field.type == 'text'">
                                    <span
                                    class="bold d-block product-subtitle"
                                    :key="'dimension-item-'+di"
                                    >{{detail_item.value}}</span>
                                </template>

                                <template v-if="detail_item.field.type == 'textarea'">
                                    <p style="white-space: break-space;" :key="'dimension-item-'+di">{{detail_item.value}}</p>
                                </template>

                                <template v-if="detail_item.field.type == 'wysiwyg'">
                                    <div :key="'dimension-item-'+di" v-html="detail_item.value"></div>
                                </template>

                            </template>


                            <v-btn outlined color="black" tile :to="'/product/'+favorite.url" width="184" height="55" class="mt-6 btn-shop-now ">
                                <span>SHOP <span class="bold" :ripple="false" elevation="0">NOW</span></span>
                            </v-btn>

                        </v-col>
                    </v-row>
                </template>
            </template> -->
            
            <div class="d-none d-md-block" v-if="path != '/furniture'">
                
                <v-carousel :hide-delimiters="true" :show-arrows-on-hover="true" :show-arrows="true" class="d-none d-md-block" v-model="carousel" :cycle="false" height="auto" light>

                    <template v-for="(favorite,fav_id) in favorites">
                        <template v-if="$route.name == 'Furniture' || ($route.name == 'FurnitureCategory' && $route.params.url == favorite.category.url) || ($route.params.url == 'new' && favorite.new)">


                            <v-carousel-item :key="'fav-'+fav_id">
                                <v-row align="center">
                                    <v-col cols="12" sm="7">
                                        <router-link :to="'/product/'+favorite.url">
                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+favorite.cover.path" :contain="true" width="100%"></v-img>
                                        </router-link>
                                    </v-col>
                                    <v-col cols="12" sm="5" style="padding-right: 144px;">
                                        <div class="mb-5">
                                            <span class="bold product-title">{{favorite.productNameLabelBold}}</span> <span class="product-title">{{favorite.productNameLabel}}</span>
                                        </div>

                                        <!-- <span class="bold d-block product-subtitle">Description</span> -->

                                        <template v-for="(detail_item, di) in favorite.details">
                                            <template v-if="detail_item.field.type == 'textarea'">
                                                <p style="white-space: break-spaces;" :key="'detail-item-'+di">{{detail_item.value}}</p>
                                            </template>

                                            <template v-if="detail_item.field.type == 'wysiwyg'">
                                                <div :key="'detail-item-'+di" v-html="detail_item.value" class="wysiwyg-featured">

                                                </div>
                                            </template>
                                        </template>


                                        <span class="bold d-block product-subtitle">Dimensions</span>
                                        <template v-for="(detail_item, di) in favorite.dimensions">
                                            <template v-if="detail_item.field.type == 'text'">
                                                <span
                                                class="bold d-block product-subtitle"
                                                :key="'dimension-item-'+di"
                                                >{{detail_item.value}}</span>
                                            </template>

                                            <template v-if="detail_item.field.type == 'textarea'">
                                                <p style="white-space:break-spaces;" :key="'dimension-item-'+di">{{detail_item.value}}</p>
                                            </template>

                                            <template v-if="detail_item.field.type == 'wysiwyg'">
                                                <div :key="'dimension-item-'+di" v-html="detail_item.value"></div>
                                            </template>

                                        </template>
                                        <div class="text-right">
                                            <v-btn outlined color="black" tile :to="'/product/'+favorite.url" :width="ancho" :height="alto" class="mt-6 btn-shop-now ml-auto">
                                                <span>SHOP <span class="bold" :ripple="false" elevation="0">NOW</span></span>
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-carousel-item>
                        </template>
                    </template>
                </v-carousel>
            </div>

            <template v-if="path == '/furniture'">

                <v-row class="my-10">
                    <v-col class="text-center">
                        <div class="d-inline-block pb-6 px-10" style="border-bottom: 1px solid grey;">
                            <span class="bold product-title" style="font-size: 38px">BEAUTY</span> <span class="product-title" style="font-size: 38px">ALWAYS WINS</span>
                        </div>
                    </v-col>
                </v-row>

                <v-row class="mb-12" justify="center">
                    <v-col cols="10" class="column-especial-4k">
                        
                        <v-row>
 
                            <template v-for="(product, product_id) in products">
                                <template v-if="!product.favorite || path == '/furniture'">
                                    <v-col cols="12" sm="6" md="6" lg="4"  :key="'product-'+product_id" class="product-column px-sm-12" @mouseover="productOver = product_id" @mouseout="productOver = -1" v-bind:class="{'opac':productOver != -1 && productOver != product_id}">
                                        <router-link :to="'/product/'+product.url" class="mb-5 d-block not-text-decoration">
                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+product.cover.path" :contain="true" class="mb-5"></v-img>
                                        </router-link>

                                        <router-link :to="'/product/'+product.url" class="menu-links d-inline-block not-text-decoration furniture-link uppercase">
                                            <span class="bold">{{product.productNameLabelBold}}</span> <span>{{product.productNameLabel}}</span>
                                            <div class="animation-line"></div>
                                        </router-link>
                                    </v-col>
                                </template>
                            </template>

                        </v-row>

                    </v-col>

                    <v-col cols="12" sm="5">
                    </v-col>
                </v-row>

            </template>
            <template v-else>
                <router-view></router-view>
            </template>
        </v-container>
    </div>    
</template>

<script>
export default {
  data() {
    return {
      products: [],
      favorites: [],
      carousel: 0,
      arrowLeft: true,
      arrowRight: true,
      productOver: -1,
    };
  },
  beforeMount: function () {
    var aux = this;
    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Products?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          populate: 1, // resolve linked collection items
          sort:{
                Collection: 1,
                url: 1
            }
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (aux.products = res.entries));

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Products?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {
            favorite: true,
          },
          populate: 1, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (aux.favorites = res.entries));
  },
  methods: {
    showPrev: function () {
      if (this.carousel == 0) {
        this.carousel = this.favorites.length - 1;
      } else {
        this.carousel--;
      }
    },
  },
  computed: {
    path: function () {
      return this.$route.fullPath;
    },
    alto: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        return 91;
      } else {
        return 70;
      }
    },
    ancho: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        return 260;
      } else {
        return 200;
      }
    },
  },
  mounted() {
    var breadcrumbs = [
      {
        text: "Home",
        link: "/",
        isLink: true,
      },
      {
        text: "Furniture",
        isLink: false,
      },
    ];
    this.$emit("updateStatus", breadcrumbs);
    gtag('config', 'UA-26953667-1', {
      'page_title' : 'Furniture',
      'page_path': '/furniture'
    });
  },
};
</script>